import productCategoryType from "./notifierTypes";

const initialState = {
  allNotifier: [],
  loading: false,
  searching: false,
  filtering: false,
  deleting:false,
  store: {},
  search: [],
  singleNotifier: {},
  editCategory: {},
  deleteCategory: {},
  testCategoryModel: {},
};
export default function notifierReducer(state = initialState, action) {
  switch (action.type) {
    case productCategoryType.GET_PRODUCT_CATEGORIES:
      return {
        ...state,
        allNotifier: action.payLoad?.data,
      };
    case productCategoryType.STORE_A_NOTIFIER:
      return {
        ...state,
        store: action.payLoad?.data?.data,
      };
    case productCategoryType.DELETE_A_NOTIFIER:
      // const deleteCategory = state.allNotifier.filter(
      //   (item) => item.id !== action.payLoad.id
      // );
      return {
        ...state,
        deleteCategory: action.payLoad.data,
      };
    case productCategoryType.EDIT_A_PRODUCT_CATEGORY:
      // const editCategories = state.allNotifier.findIndex(
      //   (item) => item.id === action.payLoad.id
      // );
      // const allNotifier = [...state.allNotifier];
      // allNotifier[editCategories] = action.payLoad;
      return {
        ...state,
        editCategory: action.payLoad.data,
      };
    case productCategoryType.SHOW_A_NOTIFIER:
      return {
        ...state,
        singleNotifier: action.payLoad.data,
      };
    case productCategoryType.TEST_PRODUCT_CATEGORY_MODEL:
      return {
        ...state,
        testCategoryModel: action.payLoad.data.data,
      };
    case productCategoryType.LOADING_NOTIFIER:
      return {
        ...state,
        loading: action.payLoad,
      };
    case productCategoryType.LOADING_SEARCH:
      return {
        ...state,
        searching: action.payLoad,
      };
    case productCategoryType.FILTERING:
      return {
        ...state,
        filtering: action.payLoad,
      };
    case productCategoryType.DELETING:
      return {
        ...state,
        deleting: action.payLoad,
      };
    case productCategoryType.SEARCH_NOTIFIER:
      return {
        ...state,
        search: action.payLoad?.data,
      };
    case productCategoryType.FILTER_NOTIFIER:
      return {
        ...state,
        allNotifier: action.payLoad?.data,
      };

    default:
      return state;
  }
}
